// Bootstrap do app — coisas que precisam rodar UMA VEZ na carga do módulo,
// antes do React montar.

// ─────────────────────────────────────────────────────────────────
// Versionamento do localStorage — purga shapes antigos entre deploys.
// Quando LS_SCHEMA_VERSION mudar (ou for a 1ª execução), todas as
// chaves transientes (carrinho, op_ctx, modal_dismissed) são apagadas.
// Tokens, perfil e KYC são preservados (não invalidam após deploy).
// ─────────────────────────────────────────────────────────────────
const LS_SCHEMA_VERSION = '3';
const LS_KEY_VERSION = 'toalugando_ls_schema_v';
const LS_TRANSIENTES = [
  'toalugando_cart_v1',           // chave antiga — purgada na migração v2→v3
  'toalugando_op_ctx',
  'toalugando_cep_locatario',
  'toalugando_cep_modal_dismissed',
];

export const purgarLocalStorageStaleSchema = () => {
  try {
    const atual = localStorage.getItem(LS_KEY_VERSION);
    if (atual !== LS_SCHEMA_VERSION) {
      LS_TRANSIENTES.forEach((k) => { try { localStorage.removeItem(k); } catch {} });
      localStorage.setItem(LS_KEY_VERSION, LS_SCHEMA_VERSION);
    }
  } catch {}
};

// ─────────────────────────────────────────────────────────────────
// OAuth hash — lê os tokens do redirect do Supabase (#access_token=...)
// no carregamento do módulo, ANTES do React montar. Limpa URL e sessão
// anterior imediatamente — o redirect traz uma conta nova, então
// descartamos qualquer login pré-existente. Retorna o objeto com tokens
// pra AppContent consumir, ou null se não havia hash de OAuth.
// ─────────────────────────────────────────────────────────────────
export const lerOAuthRedirect = () => {
  if (!window.location.hash) return null;
  const hash = new URLSearchParams(window.location.hash.substring(1));
  const accessToken = hash.get('access_token');
  const refreshToken = hash.get('refresh_token');
  const type = hash.get('type');
  if (!accessToken) return null;
  window.history.replaceState({}, '', window.location.pathname + window.location.search);
  if (type !== 'recovery') {
    localStorage.removeItem('toalugando_user');
    localStorage.removeItem('toalugando_token');
    localStorage.removeItem('toalugando_refresh');
  }
  return { accessToken, refreshToken, type };
};

// Executa imediatamente (sem await/call) — é a forma original do App.
purgarLocalStorageStaleSchema();
export const _oauthRedirect = lerOAuthRedirect();
